import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

@Injectable({
  providedIn: 'root'
})
export class TechnicienGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    
    if (!user) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Vérifier si l'utilisateur a le rôle technicien
    const roleName = user.role?.nom?.toLowerCase();
    const hasTechnicienRole = roleName === ROLES.TECH;
    
    if (!hasTechnicienRole) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    return true;
  }
}
